import React from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"styled-system"' has no exported member 'P... Remove this comment to see the full error message
import { Props as StyleProps } from 'styled-system';

import Icon from 'components/Icon';

import Aarp from 'action-opps-aarp.svg';
import DoSomething from 'action-opps-do-something.svg';
import DonorsChoose from 'action-opps-donors-choose.svg';
import GlobalGiving from 'action-opps-global-giving.svg';
import Kiva from 'action-opps-kiva.svg';
import MoveOn from 'action-opps-move-on.svg';
import NewYorkCares from 'action-opps-newyorkcares.svg';
import Nycparks from 'action-opps-nycparks.svg';
import PointsOfLight from 'action-opps-points-of-light.svg';
import VolunteerGov from 'action-opps-volunteergov.svg';
import VolunteerMatch from 'action-opps-volunteermatch.svg';

const getIconComponent = (name) => {
  switch (name) {
    case 'kiva':
      return Kiva;

    case 'nycparks':
      return Nycparks;

    case 'global-giving':
      return GlobalGiving;

    case 'volunteermatch':
      return VolunteerMatch;

    case 'move-on':
      return MoveOn;

    case 'points-of-light':
      return PointsOfLight;

    case 'aarp':
      return Aarp;

    case 'do-something':
      return DoSomething;

    case 'newyorkcares':
      return NewYorkCares;

    case 'volunteergov':
      return VolunteerGov;

    case 'donors-choose':
    default:
      return DonorsChoose;
  }
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const VolopsIcon = (
  {
    name,
    ...props
  }: StyleProps & {
    name: string;
  } // TODO: Fix this the next time the file is edited.
) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Icon component={getIconComponent(name)} {...props} />
);

export default VolopsIcon;
